import { render, staticRenderFns } from "./ResourceSelectorInput.vue?vue&type=template&id=13c82f2d&lang=pug&"
import script from "./ResourceSelectorInput.vue?vue&type=script&lang=ts&"
export * from "./ResourceSelectorInput.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceSelectorInput.vue?vue&type=style&index=0&id=13c82f2d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports